import type { FunctionComponent } from 'react';

export const VisibilityPrivateIcon: FunctionComponent = () => {
    return (
        <svg fill="none" height="32" width="32" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="15" fill="#374151" r="3" />
            <path
                d="M17.192 22.922A9.1 9.1 0 0 1 16 23c-7 0-11-8-11-8s4-8 11-8c6.326 0 10.202 6.534 10.89 7.792A6.472 6.472 0 0 0 23 13.5a6.49 6.49 0 0 0-2.131.357A5.002 5.002 0 0 0 11 15a5 5 0 0 0 5.5 4.975V20c0 1.05.25 2.043.692 2.922Z"
                fill="#374151"
            />
            <circle cx="23" cy="20" fill="#374151" r="5" />
            <path
                d="M25 18.667h-.333V18a1.667 1.667 0 0 0-3.334 0v.667H21c-.367 0-.667.3-.667.666v3.334c0 .366.3.666.667.666h4c.367 0 .667-.3.667-.666v-3.334c0-.366-.3-.666-.667-.666Zm-2 3a.669.669 0 0 1-.667-.667c0-.367.3-.667.667-.667.367 0 .667.3.667.667 0 .367-.3.667-.667.667Zm1.033-3h-2.066V18a1.034 1.034 0 0 1 2.066 0v.667Z"
                fill="#fff"
            />
        </svg>
    );
};
